import { Box, IconButton, ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import React, { useEffect, useState } from "react";
import LanguageIcon from "@mui/icons-material/Language";
import iso from "iso-639-1";
import { getReportTranslation } from "../actions/setting.action";
import { useConfig } from "../containers/ConfigContext";

function useLanguageHandle() {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const [languages, setLanguages] = useState<string[]>([]);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    getReportTranslation().then((res) => setLanguages(res.languages.concat(["en"])));
  }, []);

  return { anchorEl, open, languages, handleClick, handleClose };
}

export function SwitchLanguageButton(props: { onSwitchLanguage: (code: string) => void }) {
  const { onSwitchLanguage } = props;
  const { anchorEl, open, languages, handleClick, handleClose } = useLanguageHandle();

  return (
    <Box>
      <IconButton onClick={handleClick} sx={{ p: 0 }}>
        <LanguageIcon />
      </IconButton>
      <LanguageMenu
        anchorEl={anchorEl}
        open={open}
        handleClose={handleClose}
        languages={languages}
        onSwitchLanguage={onSwitchLanguage}
      />
    </Box>
  );
}

export function LanguageMenuItem(props: { onSwitchLanguage: (code: string) => void }) {
  const { onSwitchLanguage } = props;
  const { localized } = useConfig();
  const { anchorEl, open, languages, handleClick, handleClose } = useLanguageHandle();

  return (
    <>
      <MenuItem
        disableRipple
        onClick={(e) => {
          e.stopPropagation();
          handleClick(e);
        }}
      >
        <ListItemIcon>
          <LanguageIcon />
        </ListItemIcon>
        <ListItemText>{localized("Language")}</ListItemText>
      </MenuItem>
      <LanguageMenu
        anchorEl={anchorEl}
        open={open}
        handleClose={handleClose}
        languages={languages}
        onSwitchLanguage={onSwitchLanguage}
      />
    </>
  );
}

export function LanguageMenu(props: {
  anchorEl: HTMLElement | null;
  open: boolean;
  handleClose: () => void;
  languages: string[];
  onSwitchLanguage: (code: string) => void;
}) {
  const { anchorEl, open, handleClose, languages, onSwitchLanguage } = props;
  return (
    <Menu
      slotProps={{
        paper: {
          style: {
            maxHeight: "50vh",
          },
        },
      }}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
    >
      {languages.map((l: string) => (
        <MenuItem
          key={l}
          onClick={() => {
            onSwitchLanguage?.(l);
            handleClose();
          }}
        >
          {iso.getNativeName(l)}
        </MenuItem>
      ))}
    </Menu>
  );
}
